<template> 
<div class="pt415" id="pt415">
    <!--パンくず-->
    <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}, {title:$t('pt415.labels.title'), routerName: '', param: {}}]"></breadcrumb>
    <div class="searchCondition">
        <!--マイページタイトル-->
        <h2>{{$t('common.labels.titleHeaderOrder')}}</h2>
        <div class="">
            <!--見積一覧タイトル-->
            <div class="itemTitle">
                <h3>{{$t('pt415.labels.title')}}</h3>
            </div>
            <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt415'"/>
            <div id="warming">
                <p class="warmingMessage"></p>
            </div>
            <div v-if="pageFeedData.totalRecord > 0">
                <select v-model="reqModel.rirekiKbn" name="rirekiKbn" id="_rirekiKbnList" class="rirekiKbn" @change="changeRirekiKbn(reqModel.rirekiKbn);">
                    <option v-for="(item, index) in pt415Init.rirekiKbnList" :key="index" :value="item.KEY" >
                        {{item.VALUE}}
                    </option>
                </select>
                <div class="totalRecord">
                    <span >に作成された見積一覧</span>
                </div>
                <br>
                <br>
            </div>
            <!-- 検索結果に一致する注文がない場合 -->
            <div v-if="noResult" class="noResultMessage" >
                <span class="noResultMessage">
                    <!-- 検索条件に一致する見積がありませんでした。 -->
                    {{$t('pt415.labels.messgNoResult')}}
                </span>
            </div>
                <!-- ページャー表示 -->
                <div class="searchList">
                    <page-feed v-if="isDisplay"
                        :isDisplay="isPagingDisplay"
                        :isDisplaySort="false"
                        :pageFeedData="pageFeedData"
                        :dispPageSizeList="dispPageSizeList"
                        @search="changeSearch"
                        >
                        <template slot="TableRender">
                            <table id="cart-history" class="searchListTable">
                                <thead>
                                    <!-- No. -->
                                    <th scope="col">{{$t('pt415.labels.no')}}</th>
                                    <!-- ご見積日 -->
                                    <th scope="col">{{$t('pt415.labels.mitsumoriYmd')}}</th>
                                    <!-- 見積番号 -->
                                    <th scope="col">{{$t('pt415.labels.mitsumoriNo')}}</th>
                                    <!-- 金額（税込） -->
                                    <th scope="col">{{$t('pt415.labels.kingaku')}}</th>
                                    <!-- お支払い方法 -->
                                    <th scope="col">{{$t('pt415.labels.kessaiNm')}}</th>
                                    <!-- 見積有効期限 -->
                                    <th scope="col" >{{$t('pt415.labels.limitYmd')}}</th>
                                    <!-- カート -->
                                    <th scope="col">{{$t('pt415.labels.cart')}}</th>
                                    <!-- 見積書 -->
                                    <th scope="col">{{$t('pt415.labels.mitsumorisyo')}}</th>
                                    <!-- 直接注文 -->
                                    <th scope="col" v-if="pt415Init.directOrder == 1">{{$t('pt415.labels.doOrder')}}</th>
                                    <!-- 削除 -->
                                    <th scope="col">{{$t('pt415.labels.delete')}}</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in pt415Init.list" :key="index">
                                        <!-- No. -->
                                        <td scope="row" aria-label="No.">
                                            {{pageFeedData.fromRecord+index}}
                                        </td>
                                        <!-- ご見積日 -->
                                        <td :aria-label="$t('pt415.labels.mitsumoriYmd')">
                                            <span>{{item.MITSUMORI_YMD}}</span>
                                        </td>
                                        <!-- 見積番号 -->
                                        <td :aria-label="$t('pt415.labels.mitsumoriNo')">
                                            <span>{{item.MITSUMORI_KANRI_CD}}</span>
                                        </td>
                                        <!-- 金額（税込） -->
                                        <td align="right" :aria-label="$t('pt415.labels.kingaku')">
                                            <input-number v-model="item.SEIKYU_TAX_IN" :readonly="true" :suffix ="'円'" />
                                        </td>
                                        <!-- お支払い方法 -->
                                        <td :aria-label="$t('pt415.labels.kessaiNm')">
                                            <span>{{item.KESSAI_NM}}</span>
                                        </td>
                                        <!-- 見積有効期限 -->
                                        <td :aria-label="$t('pt415.labels.limitYmd')">
                                            <span>{{item.LIMIT_YMD}}</span>
                                        </td>
                                        
                                        <!-- カート -->
                                        <td align="center" :aria-label="$t('pt415.labels.cart')">
                                            <input class="submit-button-small" type="button" @click="doAddCartConfirm(item.MITSUMORI_KANRI_CD)" :value="$t('pt415.labels.cartBtn')">
                                        </td>
                                        <!-- 見積書出力 -->
                                        <td align="center" :aria-label="$t('pt415.labels.mitsumorisyo')">
                                            <input class="submit-button-small" type="button" @click="doPrint(item.MITSUMORI_KANRI_CD)" :value="$t('pt415.labels.output')">
                                        </td>
                                        <!-- 直接注文 -->
                                        <td align="center" :aria-label="$t('pt415.labels.doOrder')" v-if="pt415Init.directOrder==1">
                                            <input v-if="item.EXPIRDED==0" type="button" @click="doOrderConfirm(item.MITSUMORI_KANRI_CD)" :value="$t('pt415.labels.doOrder')">
                                            <span v-else>期限切れ</span>
                                        </td>
                                        <!-- 削除 -->
                                        <td align="center" :aria-label="$t('pt415.labels.delete')">
                                            <input class="submit-button-small" type="button" @click="doDeleteConfirm(item.MITSUMORI_KANRI_CD)" :value="$t('pt415.labels.delete')">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </template>
                    </page-feed>
                    <!--戻るボタン-->
                    <div id="btn_roll3" style="text-align:center;">
                        <input class="submit-button-small" type="submit" :value="$t('common.buttons.return')" @click="backUrl()">
                    </div>
                </div>
        </div>
    </div>
    <!-- 見積情報の商品をカートに追加します。<br>※見積時の商品価格は保持せず、追加時点での商品価格でカートに追加します。 -->
        <alert-confirm
            v-if="isShowAddCartAlert"
            v-bind:msgConfirm="$t('pt415.messages.confirmAddCart')"
            :okAction="doAddCart"
            :cancelAction="()=>{isShowAddCartAlert = false;}"
            @closedModal="isShowAddCartAlert = false"
            size="md"
        />
    <!--見積書の注文手続きを行います。※現在のカートにある商品はカートから削除されます。-->
        <alert-confirm
            v-if="isShowOrderAlert"
            v-bind:msgConfirm="$t('pt415.messages.confirmAddCart')"
            :okAction="doOrder"
            :cancelAction="()=>{isShowOrderAlert = false;}"
            @closedModal="isShowOrderAlert = false"
            size="md"
        />
    <!-- 削除します。よろしいですか？ -->
        <alert-confirm
            v-if="isShowAlert"
            v-bind:msgConfirm="$t('pt415.messages.confirmOrder')"
            :okAction="doDelete"
            :cancelAction="()=>{isShowAlert = false;}"
            @closedModal="isShowAlert = false"
            size="md"
        />
</div>
</template>
<script>

/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import InputCheck from 'components/InputCheck';
import InputNumber from 'components/InputNumber';
import Message from 'components/MessageEcSite';
import PageFeed from '../commonParts/PageFeed';
import SiteConstants from 'assets/const/SiteConstants.json';
import AlertConfirm from 'components/AlertConfirm';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /* 
    * Name of component
    */
    name: "PT415MemberQuotationListParts",
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare components
    */
    components:{
            InputCheck,
            InputNumber,
            Message,
            PageFeed,
            AlertConfirm,
            toastr,
            Breadcrumb
        },
    data() {
        return {
            isDisplay: false,
            noResult: false,
            rowIndex: null,
            isPagingDisplay:true,
            isLoading: false,
            siteFlg : null,
            
            isShowAlert: false,
            isShowAddCartAlert: false,
            isShowOrderAlert: false,
            reqModel:{
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                rirekiKbn:'0',
                searchKbn:'1',
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 15,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt415Init: {},
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 0,
                toRecord: 10,
                pageSize: 10,
                pageNo: 1
            },
            dispPageSizeList:[
                {value: 5,text: "5行"},
                {value: 15,text: "15行"},
                {value: 30,text: "30行"},
                {value: 45,text: "45行"},
                {value: 50,text: "50行"},
                {value: 100,text: "100行"}
            ],
            SiteConstants: SiteConstants,
            iSearch:false,
            // for validate
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            site: ""
        }
    },
    /*
    * 初期表示
    */
    mounted() {
        // Call API doInit
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            // 未ログインの場合
            if(_this.ptInitData.status == 'NG'){
                // ログイン画面へ遷移
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
            }else {
                // 検索
                if (_this.iSearch==true){
                    _this.search();
                } else {
                    _this.pt415Init = _this.ptInitData;
                    _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModels);
                    _this.search();
                }
            }
        }else{
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT415 + _this.$UrlConstants.DO_INIT, _this.reqModel).then(function(response) {
                // 未ログインの場合
                if(response.data.status == 'NG'){
                    // ログイン画面へ遷移
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                }else {
                    // 検索
                    if (_this.iSearch==true){
                        _this.search();
                    } else {
                        _this.pt415Init = response.data;
                        _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModels);
                        _this.search();
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    /*
    * メソッド
    */
    methods: {
        /*
        * 検索処理
        */
        search: function() {
            var _this = this;
            // Clear msg validate
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt415');
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT415 + _this.$UrlConstants.DO_SEARCH, _this.reqModel).then(function(response) {
                _this.pt415Init = response.data;
                if (response.data.list != null && response.data.list.length > 0) {
                    _this.pageFeedData.totalRecord = response.data.totalRecord;
                    _this.reqModel.totalRecord = response.data.totalRecord;
                    _this.pageFeedData.fromRecord = response.data.fromRecord;
                    _this.pageFeedData.toRecord = response.data.toRecord;
                    _this.pageFeedData.pageSize = response.data.pageSize;
                    _this.pageFeedData.pageNo = response.data.pageNo;
                     _this.isDisplay = true; 
                    _this.isPagingDisplay = true;
                    _this.noResult = false;
                }else{
                    _this.isDisplay = false;
                    _this.noResult = true;
                    _this.reqModel.totalRecord = 0;
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt415');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function() {
            var _this = this;
            // マイメニュー画面へ遷移
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
        },
        /*
        * 履歴時間選択
        */
        changeRirekiKbn: function(Kbn) {
            var _this = this;
            _this.reqModel.rirekiKbn = Kbn;
            _this.reqModel.pageNo = 1;
            _this.changeSearch(_this.reqModel.orderByType,_this.reqModel.pageSize,_this.reqModel.pageNo);
        },
        
        // カート追加
        doAddCartConfirm: function(mitsumoriNo) {
            this.reqModel.mitsumoriNo = mitsumoriNo;
            this.isShowAddCartAlert = true;
        },
        doAddCart: function() {
            var _this = this;
            _this.isShowAddCartAlert = false;
            common.clearMessageEcSite(_this.listIdErr,'pt415');
            _this.$emit("event-loading", true);
            var reqModel = {};
            reqModel.mitsumoriNo = this.reqModel.mitsumoriNo;

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT415 + _this.$UrlConstants.DO_ORDER, reqModel).then(function(response) {
                if(response.data.result.status == 'OK'){
                    _this.msgConfirm = _this.$i18n.t("pt415.labels.addCart");
                    toastr.success(_this.msgConfirm);
                    _this.$emit('evt-change-quantily');
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt415');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        // 直接注文
        doOrderConfirm: function(mitsumoriNo) {
            this.reqModel.mitsumoriNo = mitsumoriNo;
            this.isShowOrderAlert = true;
        },
        doOrder: function() {
            var _this = this;
            common.clearMessageEcSite(_this.listIdErr,'pt415');
            _this.$emit("event-loading", true);
            sessionStorage.removeItem('doQuotation');
            var reqModel = {};
            reqModel.mitsumoriNo = this.reqModel.mitsumoriNo;
            reqModel.doClearCart = 1;//カートクリア

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT415 + _this.$UrlConstants.DO_ORDER, reqModel).then(function(response) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(response.data.result.status == 'OK'){
                    _this.buyStep(response.data);
                }
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt415');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 購入手続きへ処理
        */
        buyStep: function(respData){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            _this.$emit("event-loading", true);
            
            var orderItems = [];
            for(var p = 0; p < respData.searchList.length; p++){
                var product = respData.searchList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                orderItems.push(order);
            }
            for(var p = 0; p < respData.searchPointList.length; p++){
                var product = respData.searchPointList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                orderItems.push(order);
            }

            var reqModel = {};
            
            reqModel.processType = 1;//_this.BUY_STEP_PROCESS;
            reqModel.orderItems = orderItems;

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_NEXT_BUY_STEPS, reqModel).then(function(response) {
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                if(response.data.status == 'OK'){
                   _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22},params: {backPageNo:104} });
                } 
                
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        // 見積書印刷
        doPrint: function(mitsumoriNo) {
            var _this = this;
            common.clearMessageEcSite(_this.listIdErr,'pt415');
            _this.$emit("event-loading", true);
            var reqModel = {};
            reqModel.mitsumoriNo = mitsumoriNo;

            //var fullPath = window.location.href;
            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            if(appPath.startsWith('/')) {
                appPath = appPath.slice(1);
            }
            reqModel.wfrBasePath = window.location.protocol + "//" + window.location.host + "/" +appPath;//fullPath.substring(0, fullPath.lastIndexOf('/'));

            axios({
                url: _this.$UrlConstants.ECSITE + _this.$UrlConstants.PT415 + _this.$UrlConstants.DO_PRINT,
                method: "POST",
                responseType: "blob", // important
                data: reqModel
            }).then(function(response) {
                var fileName = "";
                var disposition = response.headers["content-disposition"];
                if (disposition && disposition.indexOf("attachment") !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                    fileName = matches[1].replace(/['"]/g, "");
                    }
                }
                if (/*@cc_on!@*/ false || !!document.documentMode) {
                    window.navigator.msSaveBlob(new Blob([response.data]), fileName);
                } else {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                }
                //_this.search();
                _this.$emit("event-loading", false);

                //見積書出力が完了しました。
                _this.msgConfirm = _this.$i18n.t("pt415.messages.outputPdf");
                toastr.success(_this.msgConfirm);
            }).catch(async function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            if (error.request.responseType === "blob") {
                                let responseObj = await error.response.data.text();
                                error.response.data = JSON.parse(responseObj);
                            }
                            var resultValid = common.excuteValidationEcSite(error, 'pt415');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }
                    }
                }
                
            });
        },
        
        // 見積書削除
        doDeleteConfirm: function(mitsumoriNo) {
            this.reqModel.mitsumoriNo = mitsumoriNo;
            this.isShowAlert = true;
        },
        doDelete: function() {
            var _this = this;
            _this.isShowAlert = false;
            common.clearMessageEcSite(_this.listIdErr,'pt415');
            _this.$emit("event-loading", true);
            var reqModel = {};
            reqModel.mitsumoriNo = this.reqModel.mitsumoriNo;

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT415 + _this.$UrlConstants.DO_DELETE, reqModel).then(function(response) {
                _this.reqModel.pageNo = 1;
                _this.search();
                _this.$emit("event-loading", false);
                //見積書削除が完了しました。
                _this.msgConfirm = _this.$i18n.t("pt415.messages.deletePdf");
                toastr.success(_this.msgConfirm);
            }).catch(function(error) {
                _this.isDisplay = false;
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt415');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.reqModel.pageSize = pageSize;
            this.reqModel.pageNo = pageNo;
            this.reqModel.orderByType = sortNo;
            var queryString = this.getQueryString(pageSize, 'ptPageSize');

            let appPath = process.env.VUE_APP_PUBLIC_PATH;
            if(appPath.endsWith('/')) {
                appPath = appPath.slice(0, -1);
            }
            location.href = appPath + this.$route.path + '?' + queryString;
        },

        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.reqModel.pageNo;
            query.ptPageSize = this.reqModel.pageSize;
            query.sKbn = this.reqModel.searchKbn;
            query.rKbn = this.reqModel.rirekiKbn;
            
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
    },

    /*
    * Excute code after an instance is created
    */
    created: function() {
        var _this = this;
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.sKbn != null){
                this.reqModel.searchKbn = this.queryData.sKbn;
            }
            if(this.queryData.rKbn != null){
                this.reqModel.rirekiKbn = this.queryData.rKbn;
            }
            if(this.queryData.ptPageNo != null){
                this.reqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.reqModel.pageSize = this.queryData.ptPageSize;
            }
        }
        //Get param from router when contructor this.  
        var data = _this.$route.params;
        if (data.requestBack!=null){
            _this.reqModel = Object.assign({}, _this.reqModel, data.requestBack);
            _this.iSearch=true;
        }
    }
}
</script>
